// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__ws++H"};